import type { FC, ReactNode } from 'react';

interface Props {
  readonly children: ReactNode;
  readonly hasAddons?: boolean | undefined;
  readonly isNormal?: boolean;
  readonly label?: string;
  readonly name: string;
}

export const Field: FC<Props> = ({ children, hasAddons, isNormal, label, name }) => (
  <div className={'field is-horizontal'}>
    <div className={`field-label ${(isNormal ?? true) ? 'is-normal' : ''}`}>
      <label className={'label'} htmlFor={name}>
        {label}
      </label>
    </div>
    <div className={'field-body'}>
      <div className={`field ${hasAddons ? 'has-addons' : ''}`}>{children}</div>
    </div>
  </div>
);
